module.exports = __webpack_public_path__ + "ICONEmail.svg?a4b8621786eaea03bc481f2ddafa8a1a";


//////////////////
// WEBPACK FOOTER
// ./static/ICONEmail.svg
// module id = 84
// module chunks = 0